var _circle, _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6423473D7C68C8Ca767C0F7DPackaginDesignIconDarkstudioXWebflowTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 76,
    viewBox: "0 0 89 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.311,
    cy: 13.6429,
    r: 13.6429,
    fill: "#FF7020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6611 18.2979H75.7607L82.0148 74.9995H35.6611",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.718 18.2979H75.3929L71.714 74.9995H29.0392L32.718 18.2979Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.6313,
    y: 10.4551,
    width: 43.0977,
    height: 8.15493,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7021 49.1821H55.4314L60.2684 62.091L55.4314 74.9999H15.7021L13.8524 62.091L15.7021 49.1821Z",
    fill: "#060606",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22043 49.1821H46.5303L50.5771 62.091L46.5303 74.9999H5.22043L1 62.091L5.22043 49.1821Z",
    fill: "#060606",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04938 62.0918H60.6141",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6423473D7C68C8Ca767C0F7DPackaginDesignIconDarkstudioXWebflowTemplate);
export default __webpack_public_path__ + "static/media/6423473d7c68c8ca767c0f7d_packagin-design-icon-darkstudio-x-webflow-template.23846007ddab99be51564ba8af40d478.svg";
export { ForwardRef as ReactComponent };